var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"f_subtext f_xuzhi"},[_c('h2',[_vm._v("游戏下载")]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"download-game"},[_c('img',{staticClass:"download-button",attrs:{"src":'/button_down.png',"alt":"下载游戏按钮"},on:{"click":_vm.downloadGame}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }